module.exports = __webpack_public_path__ + "img/Ghost.a9f793e3.svg";